import { EmptyFieldErrors } from '@shared/errors/error-messages';
import { EParcelPlacesFormControlNames } from '../parcel-places.enums';
import { EPidApiKey } from './ii-product-identifiers.enums';

export interface PidFieldConfig {
  controlName: EParcelPlacesFormControlNames.mpid | EParcelPlacesFormControlNames.nspid | EParcelPlacesFormControlNames.spid;
  apiKey: EPidApiKey;
  label: string;
  placeholder: string;
  tooltip: string;
  maxLength: number;
  // Never required, even when PID data is mandatory for the shipment
  isAlwaysOptional: boolean;
}

export const MpidField: PidFieldConfig = {
  controlName: EParcelPlacesFormControlNames.mpid,
  apiKey: EPidApiKey.MPID,
  label: 'Артикул магазину',
  placeholder: 'Вкажіть артикул',
  tooltip: 'M-PID - ваш внутрішній ідентифікатор товару (SKU, артикул у магазині).',
  maxLength: 50,
  isAlwaysOptional: false,
};

export const NspidField: PidFieldConfig = {
  controlName: EParcelPlacesFormControlNames.nspid,
  apiKey: EPidApiKey.NSPID,
  label: 'Артикул виробника',
  placeholder: 'Вкажіть артикул',
  tooltip: 'NS-PID - оригінальний код моделі від виробника.',
  maxLength: 50,
  isAlwaysOptional: false,
};

export const SpidField: PidFieldConfig = {
  controlName: EParcelPlacesFormControlNames.spid,
  apiKey: EPidApiKey.SPID,
  label: 'Штрих-код',
  placeholder: 'Вкажіть штрих-код',
  tooltip: 'S-PID - міжнародний формат (GTIN/EAN/UPC).',
  maxLength: 30,
  isAlwaysOptional: true,
};

export const PidFields: readonly PidFieldConfig[] = [MpidField, NspidField, SpidField];

export const PidFieldErrors = {
  ...EmptyFieldErrors,
  maxlength: 'Перевищено максимальну довжину',
};

export const PidRequiredToastMessage = 'Не заповнено обов\'язкові поля позиції: Артикул магазину, Артикул виробника';
